import { Spinner } from '@nextui-org/react'
import React from 'react'

const SkeletonLoading = () => {
    return (
        <div className='flex justify-center items-center'>
            <Spinner color="danger" />
        </div>
    )
}

export default SkeletonLoading